<template>
    <v-list-item
        component="CharacterBlacklistItem"
        :class="[
            { isSmallScreen: getIsSmallScreen },
            { isSmallerScreen: getIsSmallerScreen },
            { closed: !canEditProject },
        ]"
    >
        <div class="name" :title="actor.meno_priezvisko">
            <span class="text">{{ actor.meno_priezvisko }}</span>
        </div>

        <div class="actions">
            <mp3-player
                :state="!actor.mp3 ? 'error' : ''"
                class="sample ml-auto"
                :file="getSampleMp3Url(actor.mp3)"
                :size="getIsSmallerScreen ? 'smaller' : 'small'"
                :visualizer="'project'"
            ></mp3-player>
            <btn
                v-if="canEditProject"
                :icon="'close'"
                :size="getIsSmallerScreen ? 'iconSmall' : 'icon'"
                color="transparent"
                @click="$emit('removeActor', actor.id)"
            />
        </div>
    </v-list-item>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Mp3Player from '@/components/.global/Mp3Player.vue';

export default {
    name: 'CharacterBlacklistItem',

    props: {
        actor: {
            type: Object,
            require: true,
        },
    },

    data() {
        return {};
    },

    async created() {},

    async mounted() {},

    methods: {
        ...mapActions([]),
    },

    computed: {
        ...mapGetters(['getSampleMp3Url', 'getIsSmallScreen', 'getIsSmallerScreen', 'canEditProject']),
    },

    components: {
        Mp3Player,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='CharacterBlacklistItem'] {
    min-height: auto;
    padding: 0 8px 0 15px;
    border-top: 1px solid @border;

    &.closed {
        cursor: default;
    }

    &.isSmallerScreen {
        min-height: 33px;
        height: 33px;
        padding: 0 5px 0 15px;

        .name {
            font-size: 13px;
        }
    }

    .name {
        padding: 0;
        margin: 0;
        transition: opacity 0.2s ease-in-out;
        align-items: center;
        display: flex;
        white-space: nowrap;
        overflow: hidden;
        position: relative;
        z-index: 2;

        .text {
            text-overflow: ellipsis;
            width: 100%;
            overflow: hidden;
        }
    }

    .actions {
        .flex-row;
        justify-content: flex-end;
        min-height: 40px;
        position: relative;
        margin: 0;
        margin-left: auto;
        z-index: 4;
    }
}
</style>
